// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as HtmlEntities from "../../utils/HtmlEntities.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as FirebaseError from "../../backend/FirebaseError.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as UnauthenticatedTemplate from "./UnauthenticatedTemplate.bs.jsx";

function get(state, field) {
  return state.email;
}

function set(_state, field, value) {
  return {
    email: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function ForgottenPasswordForm(props) {
  let onSubmit = props.onSubmit;
  let onGoBack = props.onGoBack;
  let form = Form.use({
    email: props.initialEmail
  }, Validators$1.schema([
    Validators$1.required("Email"),
    Validators$1.email("Email")
  ]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    Stdlib_Promise.$$catch(onSubmit(param.state.values), error => {
      FirebaseError.toFirebaseError(error);
      let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
      LogUtils.captureException(exn);
      let msg = Stdlib_JsExn.message(exn);
      let errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <UnauthenticatedTemplate.make
    isOnline={props.isOnline}
  >
    <h2>
      {"Zapomenuté heslo"}
    </h2>
    <Form.Provider.make
      value={form}
    >
      <form
        className={Styles.stack.base}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"Email"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"email"}
              inputSlot={<input
                type={"email"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`E` + HtmlEntities.nbhp + `mail`}
            />}
          />
        </fieldset>
        {tmp}
        <button
          className={Styles.button.base}
          type={"submit"}
        >
          {`Resetovat heslo`}
        </button>
      </form>
      <p>
        {`Jste tu omylem? `}
        <button
          className={Styles.link.base}
          type={"button"}
          onClick={param => onGoBack()}
        >
          {`Zpět na přihlášení.`}
        </button>
      </p>
    </Form.Provider.make>
  </UnauthenticatedTemplate.make>;
}

let make = ForgottenPasswordForm;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
